var disposed = false
function injectStyle (ssrContext) {
  if (disposed) return
  require("!!vue-style-loader!css-loader?sourceMap!../../node_modules/vue-loader/lib/style-compiler/index?{\"vue\":true,\"id\":\"data-v-409dc3d4\",\"scoped\":true,\"hasInlineConfig\":true}!less-loader!../../node_modules/vue-loader/lib/selector?type=styles&index=0!./ServiceTipTagWeb.vue")
}
var Component = require("!../../node_modules/vue-loader/lib/component-normalizer")(
  /* script */
  require("!!babel-loader!../../node_modules/vue-loader/lib/selector?type=script&index=0!./ServiceTipTagWeb.vue"),
  /* template */
  require("!!../../node_modules/vue-loader/lib/template-compiler/index?{\"id\":\"data-v-409dc3d4\",\"hasScoped\":true}!../../node_modules/vue-loader/lib/selector?type=template&index=0!./ServiceTipTagWeb.vue"),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-409dc3d4",
  /* moduleIdentifier (server only) */
  null
)
Component.options.__file = "/mnt/devops/workspace/mweb-info/src/about/ServiceTipTagWeb.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {return key !== "default" && key.substr(0, 2) !== "__"})) {console.error("named exports are not supported in *.vue files.")}
if (Component.options.functional) {console.error("[vue-loader] ServiceTipTagWeb.vue: functional components are not supported with templates, they should use render functions.")}

/* hot reload */
if (module.hot) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-409dc3d4", Component.options)
  } else {
    hotAPI.reload("data-v-409dc3d4", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./src/about/ServiceTipTagWeb.vue
// module id = 2086
// module chunks = 47